// removed by extract-text-webpack-plugin
module.exports = {"Therapy":"_3_SyoWbW","Card":"_3lP-ceeU","Downloads":"I4cdLGFL","Download":"_3C49CXS8"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/therapies/therapies-page.styles.scss
// module id = 289
// module chunks = 0